// Vendor
import { effect, ElementRef, model, Renderer2, } from '@angular/core';
import { finalize } from 'rxjs/operators';
// Constants
import { INITIAL_COMPLIANCE_DESIGNATION_TYPE_FILTER_STATE } from 'FoldersApp/apps/compliance-report-history-app/state/compliance-designation-type/compliance-designation-type.reducer';
import { INITIAL_COMPLIANCE_REPORT_TYPE_FILTER_STATE } from 'FoldersApp/apps/compliance-report-history-app/state/compliance-report-type/compliance-report-type.reducer';
import { ComplianceReportHistoryPageSortColumn } from 'FoldersApp/apps/compliance-report-history-app/constants';
import { COMPLIANCE_REPORT_HISTORY_PARAM_KEYS } from 'FoldersApp/apps/compliance-report-history-app/state/constants';
import { DESC } from 'NewAngular/constants/core.constants';
import { TODO_NOTIFICATION_TYPES, } from 'NotificationsApp/ts/features/notifications-side-menu/constants';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { ComplianceReportService } from 'FoldersApp/apps/compliance-report-history-app/services/compliance-report.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { NotificationsService } from 'NotificationsApp/ts/services/notifications.service';
import { formFlattenedObject } from 'NewAngular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "NotificationsApp/ts/services/notifications.service";
import * as i2 from "FoldersApp/apps/compliance-report-history-app/services/compliance-report.service";
import * as i3 from "AccountsApp/ts/services/accounts.service";
import * as i4 from "NewAngular/services/core/urls.service";
import * as i5 from "@angular/common";
import * as i6 from "NotificationsApp/ts/features/notifications-side-menu/components/notifications-menu-list-item/notifications-menu-list-item.component";
import * as i7 from "NotificationsApp/ts/features/notifications-side-menu/components/notifications-menu-report-history-item/notifications-menu-report-history-item.component";
const _c0 = ["regionsContainer"];
const _c1 = ["notificationsScrollContainer"];
const _c2 = ["notificationsScrollTarget"];
const _c3 = ["reportsScrollContainer"];
const _c4 = ["reportsScrollTarget"];
const _c5 = a0 => ({ active: a0 });
const _c6 = () => [];
const _c7 = a0 => ({ "notification-new": a0 });
const _forTrack0 = ($index, $item) => $item.id;
function NotificationsSideMenuComponent_table_19_tr_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 27);
    i0.ɵɵlistener("removeNotification", function NotificationsSideMenuComponent_table_19_tr_2_Template_tr_removeNotification_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.removeNotification($event)); })("notificationRead", function NotificationsSideMenuComponent_table_19_tr_2_Template_tr_notificationRead_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.markNotificationRead($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const notification_r6 = ctx.$implicit;
    i0.ɵɵproperty("notification", notification_r6)("ngClass", i0.ɵɵpureFunction1(2, _c7, !notification_r6.read));
} }
function NotificationsSideMenuComponent_table_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 25)(1, "tbody");
    i0.ɵɵtemplate(2, NotificationsSideMenuComponent_table_19_tr_2_Template, 1, 4, "tr", 26);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r4.notificationsByCategory[ctx_r4.activeTab]);
} }
function NotificationsSideMenuComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1, "No new notifications.");
    i0.ɵɵelementEnd();
} }
function NotificationsSideMenuComponent_Conditional_32_For_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 30);
} if (rf & 2) {
    const report_r9 = ctx.$implicit;
    i0.ɵɵproperty("report", report_r9);
} }
function NotificationsSideMenuComponent_Conditional_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "table", 29)(2, "tbody");
    i0.ɵɵrepeaterCreate(3, NotificationsSideMenuComponent_Conditional_32_For_4_Template, 1, 1, "tr", 30, _forTrack0);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r4.reports);
} }
function NotificationsSideMenuComponent_Conditional_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1, "No recent downloads. ");
    i0.ɵɵelement(2, "br");
    i0.ɵɵtext(3, " Run a report to see it here.");
    i0.ɵɵelementStart(4, "a", 31);
    i0.ɵɵtext(5, "View all Report History");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("href", ctx_r4.reportHistoryUrl, i0.ɵɵsanitizeUrl);
} }
export class NotificationsSideMenuComponent {
    constructor(notificationsService, complianceReportService, accountsService, urlsService, renderer) {
        this.notificationsService = notificationsService;
        this.complianceReportService = complianceReportService;
        this.accountsService = accountsService;
        this.urlsService = urlsService;
        this.renderer = renderer;
        this.topSectionPercentage = model(65, ...(ngDevMode ? [{ debugName: "topSectionPercentage" }] : []));
        this.loading = false;
        this.loadingReports = false;
        this.notifications = model([], ...(ngDevMode ? [{ debugName: "notifications" }] : []));
        this.notificationsByCategory = {
            activity: [],
            todo: [],
        };
        this.activeTab = 'activity';
        this.reportHistoryUrl = '';
        this.complianceReportFetchParams = formFlattenedObject({
            endDate: null,
            reportType: INITIAL_COMPLIANCE_REPORT_TYPE_FILTER_STATE,
            designationType: INITIAL_COMPLIANCE_DESIGNATION_TYPE_FILTER_STATE,
            startDate: null,
            sortColumn: ComplianceReportHistoryPageSortColumn.DOWNLOAD_DATE,
            sortDirection: DESC,
            title: '',
            owner: { me: true, shared_with_me: true },
        }, COMPLIANCE_REPORT_HISTORY_PARAM_KEYS);
        this.reports = [];
        this.isDragging = false;
        this.MAX_REGION_PERCENT = 85;
        this.MIN_REGION_PERCENT = 15;
        // Tolerance for sub-pixel rounding — scrollTop + clientHeight can land a fraction below
        // scrollHeight when scrolled to the very bottom, which would otherwise leave the shadow on.
        this.SCROLL_SHADOW_THRESHOLD = 1;
        this.resizeObserver = null;
        this.scrollShadowAnimationFrame = null;
        this.reportHistoryUrl = this.urlsService.FOLDERS.MY_YCHARTS_REPORT_HISTORY;
        effect(() => {
            this.notifications();
            this.setNotificationsByCategory();
        });
    }
    ngOnInit() {
        this.setNotificationsByCategory();
        this.fetchComplianceReports();
    }
    ngAfterViewInit() {
        this.resizeObserver = new ResizeObserver(() => this.scheduleScrollShadowUpdate());
        this.resizeObserver.observe(this.regionsContainer.nativeElement);
        this.scheduleScrollShadowUpdate();
    }
    ngOnDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
        if (this.scrollShadowAnimationFrame !== null) {
            cancelAnimationFrame(this.scrollShadowAnimationFrame);
        }
    }
    deleteAllNotifications() {
        this.loading = true;
        this.notificationsService
            .deleteNotifications()
            .pipe(finalize(() => {
            this.loading = false;
        }))
            .subscribe({
            next: () => {
                this.notifications.set([]);
                this.setNotificationsByCategory();
            },
            error: () => { },
        });
    }
    removeNotification(notification) {
        this.notifications.set(this.notifications().filter((n) => n.id !== notification.id));
        this.setNotificationsByCategory();
    }
    markNotificationRead(notification) {
        this.notifications.set(this.notifications().map((n) => n.id === notification.id && n.type === notification.type ? { ...n, read: true } : n));
        this.setNotificationsByCategory();
    }
    selectTab(tabType) {
        this.activeTab = tabType;
        this.scheduleScrollShadowUpdate();
    }
    setNotificationsByCategory() {
        this.notificationsByCategory = this.notifications().reduce((acc, notification) => {
            const category = TODO_NOTIFICATION_TYPES.has(notification.type) ? 'todo' : 'activity';
            acc[category].push(notification);
            return acc;
        }, { activity: [], todo: [] });
        this.scheduleScrollShadowUpdate();
    }
    fetchComplianceReports() {
        this.loadingReports = true;
        this.complianceReportService
            .getComplianceReports({ ...this.complianceReportFetchParams, page: 1 })
            .pipe(finalize(() => {
            this.loadingReports = false;
        }))
            .subscribe({
            next: (rsp) => {
                this.reports = rsp.data.items.slice(0, 7);
                this.scheduleScrollShadowUpdate();
            },
            error: () => { },
        });
    }
    onPointerDown(event) {
        event.preventDefault();
        this.isDragging = true;
        event.target.setPointerCapture(event.pointerId);
    }
    onPointerMove(event) {
        if (!this.isDragging)
            return;
        const containerRect = this.regionsContainer.nativeElement.getBoundingClientRect();
        const newTopSectionPercentage = Math.min(this.MAX_REGION_PERCENT, Math.max(this.MIN_REGION_PERCENT, ((event.clientY - containerRect.top) / containerRect.height) * 100));
        this.topSectionPercentage.set(newTopSectionPercentage);
        this.scheduleScrollShadowUpdate();
    }
    onPointerUp(event) {
        if (!this.isDragging)
            return;
        this.isDragging = false;
        this.accountsService
            .putUserPreferences({ side_menu_top_section_percentage: this.topSectionPercentage() })
            .subscribe();
        event.target.releasePointerCapture(event.pointerId);
    }
    scrollShadow(element, targetElement) {
        const elemHeight = element.scrollHeight;
        this.renderer.removeClass(targetElement, 'scrolled-bottom');
        this.renderer.removeClass(targetElement, 'scrolled-top');
        if (element.scrollTop > this.SCROLL_SHADOW_THRESHOLD) {
            this.renderer.addClass(targetElement, 'scrolled-bottom');
        }
        if (element.scrollTop + element.clientHeight < elemHeight - this.SCROLL_SHADOW_THRESHOLD) {
            this.renderer.addClass(targetElement, 'scrolled-top');
        }
    }
    scheduleScrollShadowUpdate() {
        if (!this.notificationsScrollContainer || !this.reportsScrollContainer)
            return;
        if (this.scrollShadowAnimationFrame !== null) {
            cancelAnimationFrame(this.scrollShadowAnimationFrame);
        }
        this.scrollShadowAnimationFrame = requestAnimationFrame(() => {
            this.scrollShadowAnimationFrame = null;
            this.updateScrollShadows();
        });
    }
    updateScrollShadows() {
        this.scrollShadow(this.notificationsScrollContainer.nativeElement, this.notificationsScrollTarget.nativeElement);
        this.scrollShadow(this.reportsScrollContainer.nativeElement, this.reportsScrollTarget.nativeElement);
    }
}
NotificationsSideMenuComponent.ɵfac = function NotificationsSideMenuComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotificationsSideMenuComponent)(i0.ɵɵdirectiveInject(i1.NotificationsService), i0.ɵɵdirectiveInject(i2.ComplianceReportService), i0.ɵɵdirectiveInject(i3.AccountsService), i0.ɵɵdirectiveInject(i4.UrlsService), i0.ɵɵdirectiveInject(i0.Renderer2)); };
NotificationsSideMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotificationsSideMenuComponent, selectors: [["ycn-notifications-side-menu"]], viewQuery: function NotificationsSideMenuComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
        i0.ɵɵviewQuery(_c3, 5);
        i0.ɵɵviewQuery(_c4, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.regionsContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.notificationsScrollContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.notificationsScrollTarget = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reportsScrollContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reportsScrollTarget = _t.first);
    } }, inputs: { topSectionPercentage: [1, "topSectionPercentage"], notifications: [1, "notifications"] }, outputs: { topSectionPercentage: "topSectionPercentageChange", notifications: "notificationsChange" }, standalone: false, decls: 34, vars: 18, consts: [["regionsContainer", ""], ["notificationsScrollTarget", ""], ["notificationsScrollContainer", ""], ["reportsScrollTarget", ""], ["reportsScrollContainer", ""], [1, "regions"], [1, "region", "region-top"], [1, "region-header"], [1, "region-tabs"], ["data-test-id", "todo-tab", 1, "region-tab-link", 3, "click", "ngClass"], [1, "bullet", "bullet-2"], ["data-test-id", "activity-tab", 1, "region-tab-link", 3, "click", "ngClass"], [1, "bullet", "bullet-15"], [1, "region-body"], [1, "overflow-shadow-y", "height-full"], [1, "overflow-shadow-inner", "height-full", 3, "scroll"], [1, "notifications-body", "panel-content"], ["data-test-id", "notifications-table", "class", "table table-airy table-hover mb-1", 4, "ngIf"], ["data-test-id", "notifications-empty-state", "class", "notifications-empty", 4, "ngIf"], [1, "region-drawer", 3, "pointerdown", "pointermove", "pointerup"], [1, "region", "region-bottom"], [1, "region-header", "border-b", "border-color-gray-80", "pl-12", "pr-12"], [1, "d-flex", "justify-content-between", "align-items-center", "pt-12", "pb-12"], ["tooltip", "View All Report History", "tooltip-placement", "right", 1, "text-bold", "text-underline", 3, "href"], [1, "notifications-empty"], ["data-test-id", "notifications-table", 1, "table", "table-airy", "table-hover", "mb-1"], ["ycn-notifications-menu-list-item", "", 3, "notification", "ngClass", "removeNotification", "notificationRead", 4, "ngFor", "ngForOf"], ["ycn-notifications-menu-list-item", "", 3, "removeNotification", "notificationRead", "notification", "ngClass"], ["data-test-id", "notifications-empty-state", 1, "notifications-empty"], [1, "table", "table-airy", "table-hover", "mb-1"], ["ycn-notifications-menu-report-history-item", "", 3, "report"], [1, "text-underline", "mt-2", 3, "href"]], template: function NotificationsSideMenuComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 5, 0)(2, "div", 6)(3, "div", 7)(4, "div", 8)(5, "div", 9);
        i0.ɵɵlistener("click", function NotificationsSideMenuComponent_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectTab("todo")); });
        i0.ɵɵelement(6, "div", 10);
        i0.ɵɵelementStart(7, "span");
        i0.ɵɵtext(8, "To Do");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 11);
        i0.ɵɵlistener("click", function NotificationsSideMenuComponent_Template_div_click_9_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectTab("activity")); });
        i0.ɵɵelement(10, "div", 12);
        i0.ɵɵelementStart(11, "span");
        i0.ɵɵtext(12, "Activity");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(13, "div", 13)(14, "div", 14, 1)(16, "div", 15, 2);
        i0.ɵɵlistener("scroll", function NotificationsSideMenuComponent_Template_div_scroll_16_listener() { i0.ɵɵrestoreView(_r1); const notificationsScrollTarget_r2 = i0.ɵɵreference(15); const notificationsScrollContainer_r3 = i0.ɵɵreference(17); return i0.ɵɵresetView(ctx.scrollShadow(notificationsScrollContainer_r3, notificationsScrollTarget_r2)); });
        i0.ɵɵelementStart(18, "div", 16);
        i0.ɵɵtemplate(19, NotificationsSideMenuComponent_table_19_Template, 3, 1, "table", 17)(20, NotificationsSideMenuComponent_div_20_Template, 2, 0, "div", 18);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(21, "div", 19);
        i0.ɵɵlistener("pointerdown", function NotificationsSideMenuComponent_Template_div_pointerdown_21_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onPointerDown($event)); })("pointermove", function NotificationsSideMenuComponent_Template_div_pointermove_21_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onPointerMove($event)); })("pointerup", function NotificationsSideMenuComponent_Template_div_pointerup_21_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onPointerUp($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 20)(23, "div", 21)(24, "div", 22)(25, "a", 23);
        i0.ɵɵtext(26, "Report History");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(27, "div", 13)(28, "div", 14, 3)(30, "div", 15, 4);
        i0.ɵɵlistener("scroll", function NotificationsSideMenuComponent_Template_div_scroll_30_listener() { i0.ɵɵrestoreView(_r1); const reportsScrollTarget_r7 = i0.ɵɵreference(29); const reportsScrollContainer_r8 = i0.ɵɵreference(31); return i0.ɵɵresetView(ctx.scrollShadow(reportsScrollContainer_r8, reportsScrollTarget_r7)); });
        i0.ɵɵconditionalCreate(32, NotificationsSideMenuComponent_Conditional_32_Template, 5, 0, "div", 16)(33, NotificationsSideMenuComponent_Conditional_33_Template, 6, 1, "div", 24);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵclassProp("is-dragging", ctx.isDragging);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("flex", "0 0 " + ctx.topSectionPercentage() + "%");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c5, ctx.activeTab == "todo"));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c5, ctx.activeTab == "activity"));
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngIf", (ctx.notificationsByCategory[ctx.activeTab] ?? i0.ɵɵpureFunction0(16, _c6)).length);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !(ctx.notificationsByCategory[ctx.activeTab] ?? i0.ɵɵpureFunction0(17, _c6)).length);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("flex", "1 1 auto");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("href", ctx.reportHistoryUrl, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(7);
        i0.ɵɵconditional(ctx.reports.length ? 32 : !ctx.loadingReports ? 33 : -1);
    } }, dependencies: [i5.NgClass, i5.NgForOf, i5.NgIf, i6.NotificationsMenuListItemComponent, i7.NotificationsMenuReportHistoryItemComponent], encapsulation: 2 });
